import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/wkreport/list", params, successCallback, failCallback, exceptionCallback);
	},
	merge: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/oa/wkreport/merge", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/wkreport/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/oa/wkreport/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/oa/wkreport/remove", params, successCallback, failCallback, exceptionCallback);
	},
	search: (params, successCallback, failCallback, exceptionCallback) => {
			ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/wkreport/isCanRpt", params, successCallback, failCallback, exceptionCallback);
		},
	achivelist: (params, successCallback, failCallback, exceptionCallback) => {
	 	ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/wkreport/achivelist", params, successCallback, failCallback, exceptionCallback);
	 },isCanRpt: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/wkreport/isCanRpt", params, successCallback, failCallback, exceptionCallback);
	},sp: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/wkreport/sp", params, successCallback, failCallback, exceptionCallback);
	}
}

export default api;
